import lang from '@quasar-lang-fr'
// import lang from '@node/quasar/lang/fr'


import '@quasar-styles';

import '@quasar-icons';

import '@quasar/extras/themify/themify.css' // https://themify.me/themify-icons



import '@css/animations.scss';

import '@css/app.scss';

import {
    Quasar,
    date,
    Notify,
    Dialog,
    Cookies,
    AppFullscreen,
    LoadingBar,
    Loading,
    /* , Meta */

    QLayout,
    QPageContainer,
    QPage,
    QHeader,
    QToolbar, //  QToolbarTitle,
    QMenu,
    QDrawer,
    QAvatar,
    QImg,
    QPagination,
    QDialog,
    QPopupEdit,
    QEditor,
    QPopupProxy,
    QTooltip,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QExpansionItem,
    QCard,
    QCardActions,
    QCardSection,
    QBtn,
    QBtnDropdown,
    QBtnGroup,
    QBtnToggle, //  QOptionGroup,
    QInput,
    QCheckbox,
    QSelect,
    QField,
    QColor,
    QToggle,
    QRange,
    QFile,
    QDate,
    QTime,
    QTable,
    QTh,
    QTr,
    QTd,
    // QStepper, QStep, QStepperNavigation,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QRouteTab,
    QFab,
    QFabAction,
    QIcon,
    QSeparator,
    QSpace,
    QBanner,
    QChip,
    QBar,
    QBadge,
    QScrollArea,
    QPageSticky,
    QSpinnerOval,
    QSpinnerDots,
    QSpinnerBall,
    QPageScroller,
    QLinearProgress, QCircularProgress, //, QScrollObserver,
    QKnob,
    // QCarousel, QCarouselSlide, QCarouselControl, QParallax,
    // QUploader, QTimeline, QTimelineEntry
    // QSplitter,
    // QTree,
    // QVideo,
    // QSlideItem,
    // QChatMessage,
} from 'quasar'


const quasarConfig = {
    install(app /* , options */ ) {

        app.use(Quasar, { // équivaut à  framework:{...}

            // lang, // date en anglais, en Prod !
            lang: lang,

            plugins: {
                Notify,
                Dialog,
                Cookies,
                AppFullscreen, /* Meta, */
                LoadingBar,
                Loading,
            },
            components: //componentsLoaded
            {
                date,// Meta,
                QLayout,
                QPageContainer,
                QPage,
                QHeader,
                QToolbar, //  QToolbarTitle,
                QMenu,
                QDrawer,
                QAvatar,
                QImg,
                QPagination,
                QDialog,
                QPopupEdit,
                QEditor,
                QPopupProxy,
                QTooltip,
                QList,
                QItem,
                QItemSection,
                QItemLabel,
                QExpansionItem,
                QCard,
                QCardActions,
                QCardSection,
                QBtn,
                QBtnDropdown,
                QBtnGroup,
                QBtnToggle, //  QOptionGroup,
                QInput,
                QCheckbox,
                QSelect,
                QField,
                QColor,
                QToggle,
                QRange,
                QFile,
                QDate,
                QTime,
                QTable,
                QTh,
                QTr,
                QTd,
                // QStepper, QStep, QStepperNavigation,
                QTabs,
                QTab,
                QTabPanels,
                QTabPanel,
                QRouteTab,
                QFab,
                QFabAction,
                QIcon,
                QSeparator,
                QSpace,
                QBanner,
                QBar,
                QBadge,
                QChip,
                QScrollArea,
                QPageSticky,
                QSpinnerOval,
                QSpinnerDots,
                QSpinnerBall,
                QPageScroller,
                QLinearProgress, QCircularProgress, //QScrollObserver,
                QKnob,
                // QCarousel, QCarouselSlide, QCarouselControl, QParallax,
                // QUploader, QTimeline, QTimelineEntry
                // QSplitter,
                // QTree,
                // QVideo,
                // QSlideItem,
                // QChatMessage,
            },
            framework: {
                cssAddon: true,
                iconSet: 'material-icons',
            },
            // extras: ['material-icons'],
            config: {
                loading:{
                    spinner: QSpinnerBall,
                    html: true,
                    boxClass: 'bg-grey-2 text-grey-9',
                    spinnerColor: 'primary',
                    spinnerSize: 60,
                },
                // loadingBar: {
                //     color: 'amber-8',
                //     size: '2px',
                //     position: 'top',
                //     // position: 'right',reverse:true
                // },
                brand: {
                    light: '#eceff1', // OK
                    dark: '#323232',

                    primary: '#1976D2',
                    secondary: '#26A69A',
                    accent: '#9C27B0',

                    positive: '#21BA45',
                    negative: '#C10015',
                    info: '#31CCEC',
                    warning: '#F2C037',
                },
            }
        });
        // /* app.config.globalProperties. */$q.lang.date.monthsShort = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']// pour y mettre un peu d'accents...
        // /* app.config.globalProperties. */$q.lang.date.daysShort = ['Dim.','Lun.','Mar.','Mer.','Jeu.','Ven.','Sam.'] // pour y mettre des points
        app.config.globalProperties.$q.lang.date.months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
        app.config.globalProperties.$q.lang.date.days = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi']

        // pour l'utiliser directement.. (ex. dans stores/course.js @updateStatus() )
        app.config.globalProperties.$q.Dialog = Dialog //! ATTENTION  js/stores  doit être après, dans le viteChunker.js...


        window.$q = app.config.globalProperties.$q

        // console.log('in quasar.conf.js',app.config, $q)


        if ($q.cookies.get('dark_mode') === 'true') { // défini dans HeaderUserMenu.vue
            $q.dark.set(true)
        }

        // proto.$date = date

        // // proto.$q = appCreate.config.globalProperties.$q
        // proto.$q = app.config.globalProperties.$q


        // $q.lang.set($q.lang.fr) // NONE
        // $q.lang.set(lang_fr) // OK, mais non..

        // helpers detect platform
        let platform = app.config.globalProperties.$q.platform;
        app.config.globalProperties.$_isDesktop = platform.is.desktop;
        app.config.globalProperties.$_isMobile = platform.is.mobile;
        app.config.globalProperties.$_hasTouch = platform.has.touch;
        window.$_isDesktop = platform.is.desktop;
        window.$_isMobile = platform.is.mobile;
        window.$_hasTouch = platform.has.touch;

        // proto.$q.loading.show({ // hide in actions/app@setDatas()
        //     // message: 'Bienvenue...',
        //     // boxClass: 'bg-grey-2 text-grey-8',
        //     spinnerColor: 'primary'
        // })

        // log('2',$q.lang.nativeName,$q.lang.getLocale(), $q.lang, import.meta.env)

        // $q.dialog({title:'TEST in quasar.conf',message:fn.formatDate({format:'dddd, D MMMM YYYY [à] HH[:]mm'})+'<br>'+date.formatDate(Date.now(), 'dddd, D MMMM YYYY'),html:true,cancel:true})

        // import { useQuasar } from '@quasar'

        // proto.$q = useQuasar();
        // proto.$q.iconSet.set(Quasar.iconSet.mdi)
        // proto.$q.iconSet.set(Quasar.iconSet.fontawesomeV5)
        // proto.$q.iconSet.set(proto.$q.iconSet.name)
        // proto.$q.iconSet.set(iconSet)

        // log('$q in quasar.conf', $q.cookies.get('dark_mode'))


        // QEditor toolbar
        // Vue.prototype.$toolbarForQEditor = [
        app.config.globalProperties.$toolbarForQEditor = [
            // ['save'], ['cancel'],
            ['undo', 'redo', 'bold', 'italic', 'strike'],
            ['underline', 'subscript', 'superscript'],
            ['hr', 'link', 'user_files'],
            // ['print', 'fullscreen'],
            // ['colors'], // using toolbar slots
            [{
                    // label: $q.i18n.editor.formatting,
                    icon: 'format_color_text', //$q.icon.editor.formatting,
                    // icon: 'rtt', //$q.icon.editor.formatting,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: ['p', 'h4', 'h5', 'h6', 'code'] //'h1','h2','h3',
                }, {
                    // label: $q.i18n.editor.fontSize,
                    icon: 'text_fields', //$q.icon.editor.fontSize,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'no-icons',
                    options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                }, {
                    //		label: $q.i18n.fr.editor.align,
                    icon: 'format_align_center', //$q.icon.editor.align,
                    fixedLabel: true,
                    fixedIcon: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                }
                //     ,{
                //     label: $q.i18n.editor.align,
                //     icon: $q.icon.editor.align,
                //     fixedLabel: true,
                //     options: ['left', 'center', 'right', 'justify']
                // }


                // FONTS (with Vue.prototype.$fontsForQEditor)
                //   {
                // //	label: $q.i18n.editor.defaultFont,
                // 	icon: 'font_download',//'library_books',//$q.icon.editor.font,
                // 	fixedLabel: false,
                // 	fixedIcon: true,
                // 	list: 'no-icons',
                // 	options: ['default_font', 'arial', 'arial_black', 'comic_sans', 'courier_new', 'impact', 'lucida_grande', 'times_new_roman', 'verdana']
                //   }
                // // ,'removeFormat'
            ],
            ['unordered', 'ordered', 'outdent', 'indent'], //'quote',
            // ['textcolor','bgcolor'],
            ['fullscreen', 'removeFormat', 'viewsource'],
        ];

        // QEditor fonts
        // Vue.prototype.$fontsForQEditor = {
        //     raleway: 'Raleway',
        // 	arial: 'Arial',
        // 	arial_black: 'Arial Black',
        // 	comic_sans: 'Comic Sans MS',
        // 	courier_new: 'Courier New',
        // 	impact: 'Impact',
        // 	lucida_grande: 'Lucida Grande',
        // 	times_new_roman: 'Times New Roman',
        // 	verdana: 'Verdana'
        // //	,helvetica: 'Helvetica'
        // };


        // log('in quasar.conf', proto.$q, appCreate)

        // }
        // export default s

    }
}
export default quasarConfig
